import { render, staticRenderFns } from "./EditDocumentModal.vue?vue&type=template&id=69651f97"
import script from "./EditDocumentModal.vue?vue&type=script&lang=js"
export * from "./EditDocumentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports